/**
 * AF designed — card scroller + dot pagination
 * Namespace: window.AfDesigned
 *
 * Created: 2026-08-11 11:22 IST
 * Author: Cursor Agent
 * Reason: Dot pattern navigation instead of scrollbar bar
 * Modified: 2026-08-14 18:12 IST — Desktop side arrows to change cards (Recipes scroll mode)
 */
(function () {
  'use strict';

  var ROOT_SEL = '[data-af-designed]';
  var MQ_DESKTOP = window.matchMedia('(min-width: 768px)');

  function isScrollMode(root) {
    if (!MQ_DESKTOP.matches) return true;
    return root.classList.contains('af-designed--scroll');
  }

  function setActiveDot(dots, index) {
    Array.prototype.forEach.call(dots, function (dot, i) {
      var active = i === index;
      dot.classList.toggle('is-active', active);
      if (active) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  function nearestCardIndex(scroller, cards) {
    var scrollerLeft = scroller.getBoundingClientRect().left;
    var best = 0;
    var bestDist = Infinity;

    Array.prototype.forEach.call(cards, function (card, i) {
      var dist = Math.abs(card.getBoundingClientRect().left - scrollerLeft);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    });

    return best;
  }

  function scrollToCard(scroller, cards, i) {
    if (!cards[i]) return;
    var cardRect = cards[i].getBoundingClientRect();
    var scrollerRect = scroller.getBoundingClientRect();
    var left = scroller.scrollLeft + (cardRect.left - scrollerRect.left);
    if (typeof scroller.scrollTo === 'function') {
      scroller.scrollTo({ left: left, behavior: 'smooth' });
    } else {
      scroller.scrollLeft = left;
    }
  }

  function initDesigned(root) {
    if (!root || root.getAttribute('data-af-ready') === '1') return;

    var scroller = root.querySelector('[data-af-designed-scroller]');
    var cards = root.querySelectorAll('[data-af-designed-card]');
    var dots = root.querySelectorAll('[data-af-designed-dot]');

    if (!scroller || !cards.length || !dots.length) return;

    root.setAttribute('data-af-ready', '1');

    var ticking = false;
    var arrows = null;

    function syncFromScroll() {
      if (!isScrollMode(root)) {
        if (arrows) arrows.setEnabled(false);
        return;
      }
      var i = nearestCardIndex(scroller, cards);
      setActiveDot(dots, i);
      if (arrows) arrows.syncFromScroller(scroller);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        syncFromScroll();
      });
    }

    function goBy(delta) {
      if (!isScrollMode(root)) return;
      var i = nearestCardIndex(scroller, cards) + delta;
      i = Math.max(0, Math.min(cards.length - 1, i));
      scrollToCard(scroller, cards, i);
      setActiveDot(dots, i);
      if (arrows) arrows.syncFromScroller(scroller);
    }

    Array.prototype.forEach.call(dots, function (dot) {
      dot.addEventListener('click', function () {
        if (!isScrollMode(root)) return;
        var i = parseInt(dot.getAttribute('data-af-index'), 10);
        if (isNaN(i) || !cards[i]) return;
        scrollToCard(scroller, cards, i);
        setActiveDot(dots, i);
        if (arrows) arrows.syncFromScroller(scroller);
      });
    });

    /*
     * Modified: 2026-08-14 18:12 IST
     * Author: Cursor Agent
     * Reason: Desktop arrows — step cards in Recipes (always-scroll) / mobile scroll mode
     */
    if (window.AfArrowNav && typeof window.AfArrowNav.create === 'function' && cards.length > 1) {
      arrows = window.AfArrowNav.create(root, {
        prevLabel: 'Previous card',
        nextLabel: 'Next card',
        onPrev: function () {
          goBy(-1);
        },
        onNext: function () {
          goBy(1);
        }
      });
    }

    scroller.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', syncFromScroll);

    if (typeof MQ_DESKTOP.addEventListener === 'function') {
      MQ_DESKTOP.addEventListener('change', syncFromScroll);
    } else if (typeof MQ_DESKTOP.addListener === 'function') {
      MQ_DESKTOP.addListener(syncFromScroll);
    }

    syncFromScroll();
  }

  function initAll() {
    document.querySelectorAll(ROOT_SEL).forEach(initDesigned);
  }

  window.AfDesigned = {
    init: initAll,
    initOne: initDesigned
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var root =
      event.target.querySelector(ROOT_SEL) ||
      (event.target.matches && event.target.matches(ROOT_SEL) ? event.target : null);
    if (root) {
      root.removeAttribute('data-af-ready');
      initDesigned(root);
    }
  });
})();
